module.exports = __webpack_public_path__ + "static/img/2.ea47868.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/eng/2.png
// module id = H7Ux
// module chunks = 0